import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { REQUEST_TYPES, REQUEST_STATUS } from "@/pages/PersonalArea";
import { toast } from "sonner";

function RequestRow({ r, onDone }) {
  const [reply, setReply] = useState(r.reply || "");
  const answer = async (status) => {
    try { await api.patch(`/employee-requests/${r.id}`, { status, reply }); toast.success("Risposta inviata"); onDone(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <li className="p-4 space-y-2" data-testid={`employee-request-${r.id}`}>
      <div className="flex items-center justify-between gap-2">
        <div className="font-semibold text-slate-900 text-sm">{r.user_name} · <span className="text-sky-700">{REQUEST_TYPES[r.type]}</span></div>
        <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-slate-100 text-slate-700">{REQUEST_STATUS[r.status]}</span>
      </div>
      <p className="text-sm text-slate-600 whitespace-pre-wrap">{r.message}</p>
      <div className="text-xs text-slate-400">{r.created_at.slice(0, 16).replace("T", " ")}</div>
      {r.status === "pending" ? (
        <div className="space-y-2">
          <Textarea rows={2} placeholder="Risposta (opzionale)" value={reply} onChange={(e) => setReply(e.target.value)} data-testid={`request-reply-${r.id}`} />
          <div className="flex flex-wrap gap-2">
            <Button size="sm" onClick={() => answer("approved")} className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid={`request-approve-${r.id}`}>Approva</Button>
            <Button size="sm" onClick={() => answer("done")} className="bg-sky-600 hover:bg-sky-700 text-white" data-testid={`request-done-${r.id}`}>Evasa</Button>
            <Button size="sm" variant="outline" onClick={() => answer("rejected")} data-testid={`request-reject-${r.id}`}>Rifiuta</Button>
          </div>
        </div>
      ) : r.reply && <p className="text-xs text-sky-700">Risposta: {r.reply}</p>}
    </li>
  );
}

export default function EmployeeRequests() {
  const [list, setList] = useState([]);
  const load = () => api.get("/employee-requests").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  return (
    <div className="space-y-6" data-testid="employee-requests-page">
      <header>
        <div className="text-xs uppercase tracking-widest text-sky-600 font-semibold mb-2">Team</div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">Richieste Dipendenti</h1>
      </header>
      <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
        {list.length === 0 ? <div className="p-12 text-center text-slate-400">Nessuna richiesta.</div> : (
          <ul className="divide-y divide-slate-100">{list.map((r) => <RequestRow key={r.id} r={r} onDone={load} />)}</ul>
        )}
      </div>
    </div>
  );
}
